import axios from '../axios';
import type { ApiEnvelope, TaxonomyConfigDto } from './types';

const taxonomyService = {
  async getTaxonomy() {
    const response = await axios.get<ApiEnvelope<TaxonomyConfigDto>>('/v1/manpro/config/taxonomy');
    return response.data.content;
  },
};

export default taxonomyService;
